import { router } from '@inertiajs/vue3'

let initialized = false

export function loadAmplitude(apiKey, user) {
  return new Promise((resolve) => {
    if (initialized) { resolve(); return }
    initialized = true

    Promise.all([
      import('@amplitude/analytics-browser'),
      import('@amplitude/plugin-session-replay-browser'),
    ])
      .then(([amplitude, sessionReplayModule]) => {
        const sessionReplayPlugin = sessionReplayModule.sessionReplayPlugin({
          sampleRate: 1,
        })

        amplitude.add(sessionReplayPlugin)

        amplitude.init(apiKey, {
          userId: user?.email || undefined,
          autocapture: {
            pageViews: false,
          },
        })

        if (user?.id) {
          const identify = new amplitude.Identify()
          if (user.type) { identify.set('user_type', user.type) }
          if (user.email) { identify.set('email', user.email) }
          if (user.name) { identify.set('name', user.name) }
          amplitude.identify(identify)
        }

        window.__amplitude = amplitude

        // Flush any events queued before Amplitude was ready
        if (window.__amplitudePendingEvents?.length) {
          window.__amplitudePendingEvents.forEach(({ eventName, properties }) => {
            amplitude.track(eventName, properties)
          })
          window.__amplitudePendingEvents = []
        }

        amplitude.track('Page View', {
          page_url: window.location.href,
          page_title: document.title,
        })

        resolve()
      })
      .catch((error) => {
        console.error('Failed to initialize Amplitude', error)
        resolve()
      })
  })
}

export default {
  install(app, options = {}) {
    if (import.meta.env.SSR) { return }

    const { enabled = true } = options
    if (!enabled) { return }

    router.on('navigate', (event) => {
      if (window.__amplitude) {
        window.__amplitude.track('Page View', {
          page_url: event.detail.page.url,
          page_title: document.title,
        })
      }
    })
  }
}
